import { WarningTwoTone } from "@mui/icons-material";
import { Box, SxProps, Theme, Typography } from "@mui/material";

export function ComponentUnavailable(props: { name: string, sx?: SxProps<Theme> }) {
    return <Box sx={{ ...props.sx, alignItems: 'center', display: 'flex' }}>
        <WarningTwoTone color='warning' sx={{ marginRight: '5px' }} />
        <Typography marginTop='3px'>{props.name} is unavailable</Typography>
    </Box>
}